const config = {
  builder_id: '5f2439224db04806c4f3d9b7',
  auth_domain: 'emory-demo.template',
  entity_logos: {
    plan: 'elevationPhotos[0]',
    community: 'logo',
    home: 'photos[0]',
  },
  social_links: {
    facebook: '/images/icon-social-facebook.svg',
    instagram: '/images/icon-social-instagram.svg',
    youtube: '/images/icon-social-youtube.svg',
    pinterest: '/images/icon-social-pinterest.svg',
    twitter: '/images/icon-social-twitter.svg',
    houzz: '/images/icon-social-houzz.svg',
    linkedin: '/images/icon-social-linkedin.svg',
    googleplus: '/images/icon-social-google-plus.svg',
    fallback: '/images/icon-social-baths.svg',
  },
  mapbox: {
    key: 'pk.eyJ1IjoiYnVpbGRlcmRlc2lnbnMiLCJhIjoiY2ptZ2c4b2p1MjJsdTNybnl2ZnV6bjg2OSJ9.uekOiNqFfTxBQ1evHIpc9g',
  },
  filters: {
    all: {},
  },
  filterOptions: {
    homes: [
      {
        type: 'SingleSelect',
        filter: 'AreaMetro',
        title: 'Area',
        placeholder: 'All Areas',
        routeParam: 'communityMarketAreaMetro',
        ifProducts: { BDWebsiteMetros: true },
        quickSearch: true,
      },
      {
        type: 'SingleSelect',
        filter: 'AreaSubMetro',
        title: 'City',
        placeholder: 'All Cities',
        routeParam: 'communityMarketAreaSubMetro',
        ifProducts: { BDWebsiteMetros: true },
        quickSearch: true,
      },
      {
        type: 'SingleSelect',
        filter: 'Area',
        title: 'City',
        placeholder: 'All Cities',
        routeParam: 'communityMarketArea',
        ifProducts: { BDWebsiteMetros: false },
        quickSearch: true,
      },
      {
        type: 'MultiSelect',
        filter: 'Beds',
        title: 'Beds',
        placeholder: 'All',
        quickSearch: true,
      },
      {
        type: 'MultiSelect',
        filter: 'Baths',
        title: 'Baths',
        placeholder: 'All',
      },
      {
        type: 'MultiSelect',
        filter: 'Community',
        title: 'Community',
        placeholder: 'All',
      },
      {
        type: 'MultiSelect',
        filter: 'Price',
        title: 'Price Range',
        placeholder: 'All',
        quickSearch: true,
      },
      {
        type: 'MultiSelect',
        filter: 'SchoolDistrict',
        title: 'School Districts',
        placeholder: 'All Districts',
      },
    ],
    plans: [
      {
        type: 'SingleSelect',
        filter: 'Area',
        title: 'City',
        placeholder: 'All Cities',
        routeParam: 'communityMarketArea',
        ifProducts: { BDWebsiteMetros: false },
        quickSearch: true,
      },
      {
        type: 'MultiSelect',
        filter: 'Community',
        title: 'Community',
        placeholder: 'All',
      },
      {
        type: 'MultiSelect',
        filter: 'Beds',
        title: 'Beds',
        placeholder: 'All Beds',
        quickSearch: true,
      },
      {
        type: 'MultiSelect',
        filter: 'Baths',
        title: 'Baths',
        placeholder: 'All Baths',
        quickSearch: true,
      },
      {
        type: 'MultiSelect',
        filter: 'Sqft',
        title: 'Square Feet',
        placeholder: 'All Square Feet',
        quickSearch: true,
      },
    ],
    communities: [
      {
        type: 'SingleSelect',
        filter: 'AreaMetro',
        title: 'Area',
        placeholder: 'All Areas',
        routeParam: 'communityMarketAreaMetro',
        ifProducts: { BDWebsiteMetros: true },
        onlyFilters: [],
        quickSearch: true,
      },
      {
        type: 'SingleSelect',
        filter: 'AreaSubMetro',
        title: 'City',
        placeholder: 'All Cities',
        routeParam: 'communityMarketAreaSubMetro',
        ifProducts: { BDWebsiteMetros: true },
        onlyFilters: [],
        quickSearch: true,
      },
      {
        type: 'SingleSelect',
        filter: 'Area',
        title: 'City',
        placeholder: 'All Cities',
        routeParam: 'communityMarketArea',
        ifProducts: { BDWebsiteMetros: false },
        onlyFilters: [],
        quickSearch: true,
      },
      {
        type: 'MultiSelect',
        filter: 'SchoolDistrict',
        title: 'School Districts',
        placeholder: 'All Districts',
      },
    ],
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/configuration.js